import React, { useState } from 'react'
import { IConditionSV2 } from '../../../../../../api/groupCustomerV2/groupCustomerV2Api'
import { isNumber } from 'lodash'
import { formatDateToDMY, formatDateToDMYGroup, formatPrice } from '../../../../../../until'
import { DownOutlined, UpOutlined } from '@ant-design/icons'
import '../../../style.scss'

interface Props {
  item: IConditionSV2
}

const ItemConditionDisplay: React.FC<Props> = ({ item }) => {
  const { value } = item

  const [isMore, setMore] = useState<boolean>(false)


  const baseClass = 'custom-page-css flex flex-1 text-base text-344054 font-regular'
  // Nếu có options -> hiển thị các label cách nhau dấu phẩy
  if (value?.options && value?.options.length > 0) {
    return (
      <div className={`custom-page-css flex gap-3  ${isMore ? ' items-start' : 'items-center '}`}>
        <div className={`custom-page-css flex flex-col`}>
          {
            !isMore ?
              <span className={baseClass} >
                {/* {value?.options?.map(opt => opt.label).join(', ')} */}
                {value.options[0].label}
              </span>
              :
              value?.options?.map((item, i) =>
                <span className={baseClass} key={i}>
                  {/* {value?.options?.map(opt => opt.label).join(', ')} */}
                  {item.label}
                </span>
              )
          }
        </div>
        {(value?.options.length > 1) ?
          isMore ?
            <UpOutlined className='custom-page-css text-base text-98A2B3 h-fit pt-1 ' onClick={() => setMore(!isMore)} />
            :
            <DownOutlined className='custom-page-css text-base text-98A2B3 h-fit ' onClick={() => setMore(!isMore)} />
          :
          ''
        }
      </div>

    )
  }

  // Nếu có valueNumberMin hoặc valueDateStart -> hiển thị 2 span
  if (isNumber(value?.valueNumberMin) || value?.valueDateStart) {
    return (
      <div className="flex gap-2 w-full">
        <span className={baseClass} >
          {/* {formatPrice(Number(value?.valueNumberMin)) ?? formatDateToDMY(value?.valueDateStart)} */}
          {(value?.valueNumberMin !== null && value?.valueNumberMin !== undefined) ? formatPrice(Number(value.valueNumberMin)) : formatDateToDMY(value?.valueDateStart)}
          {/* {value?.valueNumberMin ?? ''} */}
        </span>
        <span className={baseClass}>
          {value?.valueNumberMax ? formatPrice(Number(value?.valueNumberMax)) : formatDateToDMY(value?.valueDateEnd)}
        </span>
      </div>
    )
  }

  //  if (isNumber(value?.valueNumberMin) || value?.valueDateStart) {
  //     return (
  //         <div className="flex gap-2 w-full">
  //             <span className={baseClass} >
  //                 {value?.valueNumberMin ? formatPrice(Number(value?.valueNumberMin)) : formatDateToDMY(value?.valueDateStart)}
  //             </span>
  //             <span className={baseClass}>
  //                 {value?.valueNumberMax ? formatPrice(Number(value?.valueNumberMax)) : formatDateToDMY(value?.valueDateEnd)}
  //             </span>
  //         </div>
  //     )
  // }

  let keyRanger = '';
  if (value) {
    keyRanger = Object?.keys(value as any)[0];
  }

  switch (keyRanger) {
    case "valueDayFrom":
    case "valueMonthFrom":
    case "valueYearFrom":
      {
        const valueFrom = value?.valueDayFrom ?? value?.valueMonthFrom ?? value?.valueYearFrom
        const valueTo = value?.valueDayTo ?? value?.valueMonthTo ?? value?.valueYearTo
        return (
          <div className="flex gap-2 w-full">
            <span className={baseClass} >
              {valueFrom}
            </span>
            <span className={baseClass}>
              {valueTo}
            </span>
          </div>
        )

      }
    // 🟦 Trường hợp chọn NĂM
    case "valueYear":
      return (
        <div className="flex gap-2 w-full">
          <span className={baseClass} >
            {value?.valueYear}
          </span>
        </div>
      )
    case "valueMonth":
      return (
        <div className="flex gap-2 w-full">
          <span className={baseClass} >
            {value?.valueMonth}
          </span>
        </div>
      )
    case "valueDayOnly":
      return (
        <div className="flex gap-2 w-full">
          <span className={baseClass} >
            {value?.valueDayOnly}
          </span>
        </div>
      )
    case "valueMonthYear":
      return (
        <div className="flex gap-2 w-full">
          <span className={baseClass} >
            {value?.valueMonthYear}
          </span>
        </div>
      )
    case "valueDayMonthFrom":
     {
        const valueFrom = value?.valueDayMonthFrom 
        const valueTo = value?.valueDayMonthTo 
        return (
          <div className="flex gap-2 w-full">
            <span className={baseClass} >
              {valueFrom}
            </span>
            <span className={baseClass}>
              {valueTo}
            </span>
          </div>
        )

      }
  }

  // Trường hợp chỉ có 1 giá trị đơn
  return (
    <span className={baseClass}>
      {
        value?.valueDate ?
          // formatDateToDMY(value.valueDate)
          value.valueDate

          :
          value?.valueText ??
          (
            value?.valueNumber != null ?
              formatPrice(Number(value.valueNumber)) :
              null
          )
      }

    </span>
  )
}

export default ItemConditionDisplay
